import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import store from '@/stores/store';
const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

const DEFAULT_FILTERS = { offset: 0, limit: 20 };

const createState = (options = {}) => ({
    receipts: [],
    receipts_filters: DEFAULT_FILTERS,
    receipts_count: 0,
    receipts_loaded: false,
    receipts_loading: false,
    receipts_loading_errors: null,
    cancelTokenSource: null,
    _storageOptions: options || {},
});

const mutations = {
    updateReceipts(state, receipts) {
        state.receipts = receipts;
        state.receipts_loaded = true;
        state.receipts_loading = false;
        state.receipts_loading_errors = null;
    },
    updateReceiptsFilters(state, receipts_filters) {
        state.receipts_filters = receipts_filters;
        const { storageKey, fieldsToSave } = state._storageOptions;
        if (storageKey) {
            saveFiltersToStorage(storageKey, state.receipts_filters, fieldsToSave);
        }
    },
    updateReceiptsLoading(state, receipts_loading) {
        state.receipts_loading = receipts_loading;
    },
    updateReceiptsLoadingErrors(state, receipts_loading_errors) {
        state.receipts_loading_errors = receipts_loading_errors;
        state.receipts_loading = false;
    },
    updateReceiptsCount(state, receipts_count) {
        state.receipts_count = receipts_count;
    },
    updateCancelTokenSource(state, source) {
        state.cancelTokenSource = source;
    },
    updateStorageOptions(state, storage_options) {
        state._storageOptions = storage_options;
    },
};

const actions = {

    async fetchReceipts({ commit, dispatch, state }, params) {
        if (store.getters['session/current_user_permissions'].indexOf("core.view_receipt") == -1) {
            return;
        }

        // Cancel any pending request
        if (state.cancelTokenSource) {
            state.cancelTokenSource.cancel("New fetch started");
        }

        // Create new cancel token source
        const source = axios.CancelToken.source();
        commit('updateCancelTokenSource', source);

        commit('updateReceiptsLoading', true);
        commit('updateReceiptsLoadingErrors', null);

        try {
            const response = await axios.get("/api/receipts/", {
                params: state.receipts_filters,
                cancelToken: source.token,
            });
            commit('updateReceipts', response.data.results);
            commit('updateReceiptsCount', response.data.count);
            return response;
        } catch (xhr_error) {
            // Ignore cancelled requests
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateReceiptsLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateReceiptsLoading', false);
        }
    },

    async init({ commit, dispatch, state }, params) {
        commit('updateReceipts', []);
        
        // Update storage options if provided
        if (params.storageOptions !== undefined) {
            await commit('updateStorageOptions', params.storageOptions);
        }
        
        // Load filters from localStorage if storage is configured
        await commit('updateReceiptsFilters', { 
            ...DEFAULT_FILTERS, 
            ...(state._storageOptions?.storageKey ? loadFiltersFromStorage(state._storageOptions?.storageKey, {}) : {}),
            ...(params.filters || {})
        });
    },
};


export default (options = {}) => ({
    namespaced: true,
    state: createState(options),
    mutations,
    actions
});